import { useRef } from "react";

import { focusInPlace } from "./no-scroll.ts";

/**
 * El foco vuelve a quien abrió el diálogo.
 *
 * Los diálogos de la digitación se abren por estado --un atajo, un botón de
 * la barra--, no con un `DialogTrigger`, y Radix devuelve el foco a su
 * trigger: sin él, quedaba en el `body` y la mano perdía su sitio. Esto
 * recuerda dónde estaba el foco al abrir y lo devuelve al cerrar, sin
 * desplazar nada (`focusInPlace`).
 *
 * Devuelve el `onCloseAutoFocus` del `DialogContent`.
 */
export const useReturnFocus = (open: boolean) => {
  const opener = useRef<HTMLElement | null>(null);
  const wasOpen = useRef(false);
  if (open && !wasOpen.current) {
    const active = document.activeElement;
    opener.current =
      active instanceof HTMLElement && active !== document.body ? active : null;
  }
  wasOpen.current = open;
  return (event: Event) => {
    event.preventDefault();
    const target = opener.current;
    opener.current = null;
    if (target?.isConnected === true) focusInPlace(target);
  };
};
